export default __webpack_public_path__ + "static/media/Honda_logo.b81f0fe3.png";